<nav class="navbar navbar-expand-sm navbar-toggleable-sm top-bar">
  <div class="container-fluid">
    <a class="navbar-brand top-menu-modules-logo" routerLink="/"> </a>
    <div class="navbar-collapse collapse justify-content-between">
      <ul class="navbar-nav">
        @if (hasRole('UserAdmin', 'Administrator')()) {
          <li ngbDropdown class="nav-item">
            <a
              class="nav-link text-light"
              ngbDropdownToggle
              role="button"
              [class.link-active]="
                rau.isActive ||
                raz.isActive ||
                ram.isActive ||
                rac.isActive ||
                rap.isActive ||
                rad.isActive ||
                raj.isActive ||
                rax.isActive ||
                rat.isActive ||
                ray.isActive ||
                rao.isActive ||
                ras.isActive ||
                (ral.isActive && hasRole('Administrator')())
              "
              >Anagrafiche</a
            >
            <ul ngbDropdownMenu class="dropdown-menu">
              <li>
                <a
                  [hidden]="!hasRole('UserAdmin')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #rau="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'users']"
                  >Utenti</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #raz="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'products']"
                  >Matricole</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #ram="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'models']"
                  >Modelli</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #rac="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'customers']"
                  >Clienti</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #rap="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'plants']"
                  >Stabilimenti</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #rad="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'departments']"
                  >Reparti</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #raj="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'calendar']"
                  >Calendario</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #rax="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'phases']"
                  >Fasi</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #rat="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'templates']"
                  >Template</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #ray="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'properties']"
                  >Proprietà</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #rao="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'operators']"
                  >Operatori</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #ras="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'reasons']"
                  >Causali</a
                >
              </li>
              <li>
                <a
                  [hidden]="!hasRole('Administrator')() || hasRole('PriceListManager')()"
                  ngbDropdownItem
                  routerLinkActive="link-active"
                  #ral="routerLinkActive"
                  [routerLink]="['/', 'anagrafiche', 'colors']"
                  >Colori</a
                >
              </li>
            </ul>
          </li>
        }
        @if (hasRole('JobManager')()) {
          <li ngbDropdown class="nav-item">
            <a
              class="nav-link text-light"
              ngbDropdownToggle
              role="button"
              [class.link-active]="rst.isActive || rsp.isActive || rsm.isActive || rsd.isActive || rse.isActive"
            >
              Supervisione
            </a>
            <ul ngbDropdownMenu class="dropdown-menu">
              <li><a ngbDropdownItem routerLinkActive="link-active" #rsp="routerLinkActive" [routerLink]="['/', 'statistiche', 'park']">Giro scocche</a></li>
              <li>
                <a ngbDropdownItem routerLinkActive="link-active" #rst="routerLinkActive" [routerLink]="['/', 'statistiche', 'tracking']">Giro stabilimenti</a>
              </li>
              <li><a ngbDropdownItem routerLinkActive="link-active" #rsd="routerLinkActive" [routerLink]="['/', 'statistiche', 'delays']">Anomalie</a></li>
              <li><a ngbDropdownItem routerLinkActive="link-active" #rsm="routerLinkActive" [routerLink]="['/', 'statistiche', 'missings']">Mancanti</a></li>
              <li><a ngbDropdownItem routerLinkActive="link-active" #rsn="routerLinkActive" [routerLink]="['/', 'commesse', 'job', 0]">Nuova Commessa</a></li>
              <li><a ngbDropdownItem routerLinkActive="link-active" #rse="routerLinkActive" [routerLink]="['/', 'report']">Report</a></li>
            </ul>
          </li>
        }
        @if (hasRole('PriceListManager')()) {
          <li ngbDropdown class="nav-item">
            <a class="nav-link text-light" ngbDropdownToggle role="button" [class.link-active]="rsc.isActive || rsl.isActive">Listini</a>
            <ul ngbDropdownMenu class="dropdown-menu">
              <li><a ngbDropdownItem routerLinkActive="link-active" #rsc="routerLinkActive" [routerLink]="['/', 'anagrafiche', 'colors']">Colori</a></li>
              <li><a ngbDropdownItem routerLinkActive="link-active" #rsl="routerLinkActive" [routerLink]="['/', 'pricelist']">Preventivi</a></li>
            </ul>
          </li>
        }
        <li class="nav-item align-items-center">
          <a class="nav-link text-light" [routerLink]="['/', 'operator']" routerLinkActive="link-active" [routerLinkActiveOptions]="{ exact: true }"
            >Operatore</a
          >
        </li>
      </ul>
      <ul class="navbar-nav justify-self-end">
        @if (username(); as usr) {
          <li class="nav-item" ngbDropdown>
            <a class="nav-link text-light align-items-center user-container" ngbDropdownToggle>
              <i class="bi bi-person-circle my-icon me-2"></i>
              {{ usr }}
            </a>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
              <a ngbDropdownItem [routerLink]="['/', 'password']">
                <i class="bi bi-key-fill my-icon me-3"></i>
                <span i18n="@@changePassword">Change password</span>
              </a>
              <a ngbDropdownItem (click)="logout()">
                <i class="bi bi-box-arrow-right my-icon me-3"></i>
                <span>Logout</span>
              </a>
            </div>
          </li>
        } @else {
          <li class="nav-item">
            <a class="nav-link text-light" (click)="login()" href="#">Login</a>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
@for (toast of toasts(); track toast) {
  <ngb-toast
    [class]="toast.classname"
    class="position-fixed bottom-0 end-0 m-3"
    style="z-index: 1000"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    (hidden)="removeToast(toast)"
    [header]="toast.header"
  >
    {{ toast.body }}
  </ngb-toast>
}
<div class="mt-2">
  <router-outlet></router-outlet>
</div>
